import { REQUESTS } from '../../constants/backend';
import { objectToCamelCase } from '../../utils/background/Utils';
import { sendRequest } from './backendCommon';

export const types = {
    SET_SNOOZE_TIMER_SUCCESS: '@bg/SET_SNOOZE_TIMER_SUCCESS',
    SET_SNOOZE_TIMER_FAIL: '@bg/SET_SNOOZE_TIMER_FAIL',

    SNOOZE_TRAINER: '@bg/SNOOZE_TRAINER',
    SNOOZE_TRAINER_FAIL: '@bg/SNOOZE_TRAINER_FAIL',

    SNOOZE_COUNTDOWN: '@bg/SNOOZE_COUNTDOWN'
};

type Dispatch = (action: unknown) => unknown;

export const setSnoozeTimer = (snoozeTimer: number) => (dispatch: Dispatch) => {
    const payload = {
        body: objectToCamelCase({ snoozeFor: String(snoozeTimer) })
    };

    const onSuccess = ({ snoozeFor }: { snoozeFor: number }) => {
        dispatch({
            type: types.SET_SNOOZE_TIMER_SUCCESS,
            payload: { snoozeFor }
        });
    };

    const onError = (error: unknown) => {
        dispatch({ type: types.SET_SNOOZE_TIMER_FAIL, error });
    };

    dispatch(sendRequest(REQUESTS.PATCH_USER_PROFILE, { payload, onSuccess, onError }));
};
